import DashboardApi from "./api/dashboardApi";
import getPricingEstimate from "./get-pricing-estimate";

export const getAvailableServices = async (params) => {
  const {
    serviceTypes,
    companyId,
    botId,
    quoteId,
    estimate,
    skipMeasurement = false,
    answers,
    onboarding,
    preview,
    street,
    city,
    postalCode,
    county,
    state,
    country,
  } = params;
  try {
    const estimateToSend = getPricingEstimate({ estimate, skipMeasurement });
    const payload = {
      serviceTypes,
      companyId,
      quoteId,
      botId,
      estimate: estimateToSend,
      answers,
      street,
      city,
      postalCode,
      county,
      state,
      country,
    };
    const response = await DashboardApi.post(
      `/v1/rtp/quote/services${
        onboarding ? "?onboarding=true" : preview ? "?preview=true" : ""
      }`,
      payload,
    );

    // Handle new response structure: { programs: [...], summary: {...}, config: {...} }
    // Also support legacy array response for backward compatibility
    const data = response.data;
    const programs = Array.isArray(data) ? data : data.programs || [];

    // Get selected services from localStorage
    const selectedServices = JSON.parse(
      localStorage.getItem("selectedServices") || "[]",
    );

    // Sort services by alwaysOnTop flag
    const ontop = programs.filter((i) => i.alwaysOnTop);
    const notOnTop = programs.filter((i) => !i.alwaysOnTop);
    const allServices = [...ontop, ...notOnTop];

    // Filter out selected services and add pricing
    const filteredUpsellServices = allServices
      .filter((service) => service.isUpsell)
      .map((service) => {
        // Use pre-calculated pricing from server (calculatedPricing.application.displayPrice)
        // Fall back to service.appFirstCost if calculatedPricing not available
        const applicationNetPrice =
          service.calculatedPricing?.application?.displayPrice ??
          service.appFirstCost ??
          0;

        // Check if service exists in localStorage and update selected status
        const storedService = selectedServices.find(
          (stored) => stored.id === service.id,
        );

        // Return service with appFirstCost added
        return {
          ...service,
          appFirstCost: applicationNetPrice,
          selected: storedService ? storedService.selected : false,
        };
      });

    return filteredUpsellServices;
  } catch (error) {
    console.log("Error fetching available services:", error);
    return [];
  }
};
